import Button from "@Front/Components/DesignSystem/Button";
import classes from "../classes.module.scss";

type BottomButtonSectionProps = {
	bottomButton: {
		text: string;
		link?: string;
		onClick?: () => void;
	};
	onClick: () => void;
};

export function BottomButtonSection(props: BottomButtonSectionProps): React.JSX.Element {
	const { bottomButton, onClick } = props;

	return (
		<div className={classes["bottom-container"]}>
			<Button fullwidth onClick={onClick}>
				{bottomButton.text}
			</Button>
		</div>
	);
}
